import { FormlyFieldConfig } from "@ngx-formly/core";
import { map } from "rxjs";

export class ProjectForm {
    fields: FormlyFieldConfig[];

    actionText = 'projects.button.new';

    constructor(translateService, user, config?) {

      this.fields = [
          {
              key: 'name',
              type: 'input',
              wrappers: ['default-wrapper'],
              props: {
              required: true
              },
              expressions: {
                'props.label': translateService.stream('fields.name')
              }
          },
          {
              key: 'description',
              type: 'input',
              wrappers: ['default-wrapper'],
              props: {
              required: false
              },
              expressions: {
                'props.label': translateService.stream('fields.description')
              }
          }
      ]
    }    
}

export class EditProjectForm {
  fields: FormlyFieldConfig[];
  model: {};
  actionText = 'button.save';

  constructor(translateService, project, user, config?) {
    // this.model = measurement;

    this.fields = [
      {
        key: 'name',
        type: 'input',
        wrappers: ['default-wrapper'],
        defaultValue: project.name,
        props: {
          required: true,
        },
        expressions: {
          'props.label': translateService.stream('fields.name')
        }
      },
      {
        key: 'description',
        type: 'input',
        wrappers: ['default-wrapper'],
        defaultValue: project.description,
        props: {
          required: false
        },
        expressions: {
          'props.label': translateService.stream('fields.description')
        }
      },
    ]
  }
}

export class AdminCreateProjectForm {
    fields: FormlyFieldConfig[];

    actionText = 'projects.button.new';

    constructor(translateService, dataUsers, dataCompanies, user, config?) {

    const companies: {value: string | null, label: string}[] = [];
    for(const company of dataCompanies) companies.push({value: company['_id'], label: company['name'] });

    const users: {value: string | null, label: string}[] = [];
    for(const user of dataUsers) users.push({value: user['_id'], label: `${user['name']} (${user['email']})` });

      this.fields = [
          {
              key: 'name',
              type: 'input',
              wrappers: ['default-wrapper'],
              props: {
              required: true
              },
              expressions: {
                'props.label': translateService.stream('fields.name')
              }
          },
          {
              key: 'description',
              type: 'input',
              wrappers: ['default-wrapper'],
              props: {
              required: false
              },
              expressions: {
                'props.label': translateService.stream('fields.description')
              }
          }
      ]

      if (user.roles.includes('superadmin')) {
        this.fields.push(
          {
              key: 'owner',
              type: 'select',
              wrappers: ['default-wrapper'],
              props: {
                options: users,
                required: true
              },
              expressions: {
                'props.label': translateService.stream('fields.owner')
              }
          },
          {
              key: 'company',
              type: 'select',
              wrappers: ['default-wrapper'],
              props: {
                options: companies,
                required: true
              },
              expressions: {
                'props.label': translateService.stream('fields.company')
              }
          },
        )
      }
    }
}

export class AdminEditProjectForm {
    fields: FormlyFieldConfig[];

    actionText = 'button.save';

    constructor(translateService, currentData, dataUsers, dataCompanies, dataAddresses, user, config?) {

        const companies: {value: string | null, label: string}[] = [];
        for(const company of dataCompanies) companies.push({value: company['_id'], label: company['name'] });

        const users: {value: string | null, label: string}[] = [];
        for(const user of dataUsers) users.push({value: user['_id'], label: `${user['name']} (${user['email']})` });

        const addresses: {value: string | null, label: string}[] = [];
        if (user.roles.includes('superadmin') && dataAddresses.length) {
          for(const address of dataAddresses) addresses.push({value: address['_id'], label: address['name'] });
        }

        this.fields = [
          {
              key: 'name',
              type: 'input',
              wrappers: ['default-wrapper'],
              defaultValue: currentData.name,
              props: {
                required: true
              },
              expressions: {
                'props.label': translateService.stream('fields.name')
              }
          },
          {
              key: 'description',
              type: 'input',
              wrappers: ['default-wrapper'],
              defaultValue: currentData.description,
              props: {
              required: false
              },
              expressions: {
                'props.label': translateService.stream('fields.description')
              }
          },
          {
              key: 'shared_w',
              type: 'multiselect',
              wrappers: ['default-wrapper'],
              defaultValue: currentData.shared_w,
              props: {
                options: users,
                required: false
              },
              expressions: {
                'props.label': translateService.stream('fields.shared_W')
              }
          },
          {
              key: 'shared_r',
              type: 'multiselect',
              wrappers: ['default-wrapper'],
              defaultValue: currentData.shared_r,
              props: {
                options: users,
                required: false
              },
              expressions: {
                'props.label': translateService.stream('fields.shared_R')
              }
          },
      ]

      if (user.roles.includes('superadmin')) {
        this.fields.push(
          {
              key: 'owner',
              type: 'select',
              wrappers: ['default-wrapper'],
              defaultValue: currentData.owner,
              props: {
                options: users,
                required: true
              },
              expressions: {
                'props.label': translateService.stream('fields.owner')
              }
          },
          {
              key: 'company',
              type: 'select',
              wrappers: ['default-wrapper'],
              defaultValue: currentData.company,
              props: {
                options: companies,
                required: true
              },
              expressions: {
                'props.label': translateService.stream('fields.company')
              }
          },
          {
                key: 'addressInvoicing',
                type: 'select',
                defaultValue: currentData.addressInvoicing,
                props: {
                    options: addresses,
                },
                expressions: {
                    'props.label': translateService.stream('fields.address-invoicing')
                }
            },
            {
                key: 'addressShipping',
                type: 'select',
                defaultValue: currentData.addressShipping,
                props: {
                    options: addresses,
                    multiple: true,
                },
                expressions: {
                    'props.label': translateService.stream('fields.address-shipping')
                }
            },
        )
      }
    }
}